<template>
  <div id="app" >
    <div class="row no-gutters">
      <div class="col-md-2" style="display:none">
        <img src="https://sunumecano.com/assets/images/polar-repairs.png" alt="login" class="login-card-img">
      </div>
      <div class="col-md-12" id="inscription">
        <router-view></router-view>
       </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
  font-family: "Karla", sans-serif;
  min-height: 100vh; }

.brand-wrapper {
  margin-bottom: 19px; }
  .brand-wrapper .logo {
    height: 87px; }

.help-block{
  font-size: 14px;
   color: #ff2d11;

}
.login-card {
  border: 0;
  border-radius: 27.5px;
  box-shadow: 0 10px 30px 0 rgba(172, 168, 168, 0.43);
  overflow: hidden; }
  .login-card-img {
    border-radius: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover; }
  .login-card .card-body {
    padding: 85px 60px 60px; }
    @media (max-width: 422px) {
      .login-card .card-body {
        padding: 35px 24px; } }
  .login-card-description {
    font-size: 25px;
    color: #000;
    font-weight: normal;
    margin-bottom: 23px; }

    .label-name {
    font-size: 20px;
    color: #000;
    font-weight: normal;

    margin-left: -15px;
}

    #googlesignin {
      max-width: 326px !important;
      padding: 13px 20px 12px ;
      background-color: #e9ecef;
      border-radius: 4px ;
      font-size: 17px;
      font-weight: bold;
      line-height: 20px;
      color: #000;
      margin-bottom: 24px ;
      cursor: pointer;
 }

    #googlesignin > .signinButton {
     padding: 5px 19px 6px;
     width: 100% !important;
     min-height: 45px;
      border-radius: 4px;
     font-size: 17px;
     font-weight: bold;
     line-height: 20px;
     margin-bottom: 24px;
     cursor: pointer;
    }
    #logo_google{
      vertical-align: text-bottom;
      box-sizing: border-box;
      cursor: pointer;

    }
    #logo_google >svg {
      width: 100%;
      height: 100%;
      display: block;
    }
    #text_google{
      font-weight: normal;
      width: 80%;
      text-align: center;


    }
    .elembuttonG{
      display: inline-block;
    }
  .login-card form {
   /* max-width: 326px;*/
     width: 100%;
  }
  .login-card .form-control {
    border: 1px solid #d5dae2;
    padding: 15px 25px;
    margin-bottom: 2px;
    min-height: 45px;
    font-size: 13px;
    line-height: 15;
    font-weight: normal; }
    .login-card .form-control::-webkit-input-placeholder {
      color: #919aa3; }
    .login-card .form-control::-moz-placeholder {
      color: #919aa3; }
    .login-card .form-control:-ms-input-placeholder {
      color: #919aa3; }
    .login-card .form-control::-ms-input-placeholder {
      color: #919aa3; }
    .login-card .form-control::placeholder {
      color: #919aa3; }
  .login-card .login-btn {
    padding: 13px 20px 12px;
    background-color: #000;
    border-radius: 4px;
    font-size: 17px;
    font-weight: bold;
    line-height: 20px;
    color: #fff;
    margin-bottom: 24px; }
    .login-card .login-btn:hover {
      border: 1px solid #000;
      background-color: transparent;
      color: #000; }
  .login-card .forgot-password-link {
    font-size: 14px;
    color: #919aa3;
    margin-bottom: 12px; }
  .login-card-footer-text {
    font-size: 16px;
    color: #0d2366;
    margin-bottom: 60px; }
    @media (max-width: 767px) {
      .login-card-footer-text {
        margin-bottom: 24px; } }
  .login-card-footer-nav a {
    font-size: 14px;
    color: #919aa3; }

    .alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}

.alert-forbidden p {
      color: #ff2d11;
      font-size: 14px;
}
.list-level{
  padding-left: 0px !important;

}
.list-level > li {
  display: inline;
  list-style-type: none;
  font-weight: bold;
  text-decoration: none;
  color: #008347 !important;

}
.list-level > li > a  {

  text-decoration: none;
  color: #008347 !important;

  /*color: #00a65ad4;*/
}

.signup-green{
   color: #008347 !important;
   font-weight: bold;

}
/*# sourceMappingURL=popupage.css.map */

</style>



// WEBPACK FOOTER //
// src/App.vue